import axios from 'axios';

class ApiRequest {
  get REQUEST_GET () {
    return 'get';
  }

  get REQUEST_DOWNLOAD () {
    return 'download';
  }

  get REQUEST_POST () {
    return 'post';
  }

  get REQUEST_FILEUPLOAD () {
    return 'fileupload';
  }

  get REQUEST_PATCH () {
    return 'patch';
  }

  setPublicParams (session, router, store) {
    this.session = session;
    this.router = router;
    this.store = store
  }

  userHasPermission (hasPerm, clientApiId = null, hasClientPerm = null) {
    if (this.session) {
      if (!Array.isArray(hasPerm)) {
        hasPerm = [hasPerm];
      }
      if (hasClientPerm && !Array.isArray(hasClientPerm)) {
        hasClientPerm = [hasClientPerm];
      }
      const permissions = this.session.get('permissions');
      if (permissions && hasPerm.filter(Set.prototype.has, new Set(permissions)).length > 0) {
        return true;
      }
      if (hasClientPerm) {
        const clientPerm = this.session.get('client_permissions');
        if (clientPerm && clientPerm[clientApiId]) {
          if (hasClientPerm.length === 0 || hasClientPerm.filter(key => clientPerm[clientApiId][key] == 1).length > 0) {
            return true;
          }
        }
      }
    }
    return false;
  }

  addGetParamsToPath (path, filterValues, hasGetParams = false) {
    if (!filterValues) {
      return path;
    }
    for (const [key, value] of Object.entries(filterValues)) {
      let getParamVal = value;
      if (value && typeof (value) === 'object' && value.api_id) {
        getParamVal = value.api_id;
      }
      if (getParamVal && getParamVal.length > 0) {
        if (hasGetParams) {
          path += '&';
        } else {
          path += '?';
          hasGetParams = true;
        }
        if (typeof (getParamVal) === 'object') {
          path += key + '=' + encodeURIComponent(getParamVal.join(';'));
        } else {
          path += key + '=' + encodeURIComponent(getParamVal);
        }
      }
    }
    return path;
  }

  getRequestUrl (path) {
    const url = (process.env.VUE_APP_API_URL).replace('{BASEURL}', window.location.host);
    return url + path
  }

  request (path, method, reqData = [], callback = null) {
    const self = this;
    const header = {};
    if (this.session && this.session.get('accessToken')) {
      header.Authorization = 'Bearer ' + this.session.get('accessToken');
    }
    const cancelRequest = axios.CancelToken.source();
    const baseMethod = method;
    if (baseMethod === self.REQUEST_DOWNLOAD) {
      method = self.REQUEST_GET;
      if (reqData && Object.keys(reqData).length > 0) {
        method = self.REQUEST_POST;
      }
    }
    if (method === self.REQUEST_FILEUPLOAD) {
      method = self.REQUEST_POST;
      header['Content-Type'] = 'multipart/form-data';
    }
    axios({
      method: method,
      url: this.getRequestUrl(path),
      data: reqData,
      cancelToken: cancelRequest.token,
      headers: header,
      validateStatus: () => true
    })
      .then(function (response) {
        const data = {
          error: false,
          data: null,
          captcha: (response.data && response.data.captcha) ? response.data.captcha : null
        }
        if (response.status === 200 && !response.data.error) {
          data.data = (response.data && response.data.data) ? response.data.data : null;
          data.paging = (response.data && response.data.paging) ? response.data.paging : null;
        } else {
          if (response.status === 401) {
            self.session.destroy();
            self.router.push('/login');
          }
          data.error = true;
          data.messageCodes = ['failed'];
          if (response.data.error) {
            data.messageCodes = response.data.errorCodes;
          }
          if (data.messageCodes.includes('maintenance-on')) {
            self.store.dispatch('setMaintenanceOn');
          }
          if (data.messageCodes.includes('access-denied')) {
            self.router.push('/home');
          }
          if (data.messageCodes.includes('error.usertoken')) {
            self.session.destroy();
            if (!(self.router.history && self.router.history.current && self.router.history.current.name == 'menu.user.login')) {
              self.router.push('/login');
            }
          }
        }
        if (baseMethod === self.REQUEST_DOWNLOAD && !data.error && data.data && data.data.base64) {
          const link = document.createElement('a');
          link.href = data.data.base64;
          link.setAttribute('download', data.data.filename);
          link.click();
        }
        callback(data);
      })
      .catch(function (error) {
        if (error.message !== 'changed search query') {
          console.log(error);
          const data = {
            error: true,
            message: null,
            // Used to translate error
            messageCodes: ['failed']
          };

          if (error.response && error.response.data) {
            data.messageCodes = error.response.data.errorCodes;
          }
          callback(data);
        }
      });
    return cancelRequest;
  }

  getApiResponseErrorMessage (response, component, fieldOverwrite = {}) {
    let message = response.message;
    if (response.messageCodes) {
      message = '';
      for (let i = 0; i < response.messageCodes.length; i++) {
        if (i > 0) {
          message += '. ';
        }
        const parts = response.messageCodes[i].split(',');
        if (parts.length > 1) {
          const keyName = parts[1].split('.');
          parts[1] = [];
          keyName.forEach(function (val) {
            if (isNaN(parseInt(val))) {
              parts[1].push(val);
            }
          });
          let fieldName = parts[1].join('.');
          if (fieldOverwrite[fieldName]) {
            fieldName = fieldOverwrite[fieldName];
          }
          message += component.$t('api.' + parts[0], { field: component.$t(fieldName) })
        } else {
          message += component.$t('api.' + response.messageCodes[i]);
        }
      }
    }

    return message;
  }

  createFormData (editEl, keys, basekey, component, fileRequired = true) {
    const jsonData = {};
    for (const key of keys) {
      if (key !== 'files') {
        jsonData[key] = editEl[key]
      }
    }

    const reqData = new FormData();
    reqData.append(basekey, JSON.stringify(jsonData));
    let hasErrors = false;
    if (editEl.files) {
      editEl.files.forEach((el, key) => {
        if (el.deleted || (fileRequired && el.id && !(el.filename || el.file))) {
          reqData.append(basekey + '_filedata[' + key + ']', JSON.stringify({ id: el.id, deleted: true }));
        } else if (el.filename || el.file) {
          if (el.file) {
            reqData.append(basekey + '_files[' + key + ']', el.file);
          }
          reqData.append(basekey + '_filedata[' + key + ']',
            JSON.stringify({ id: el.id, title: el.title, locale: (el.locale ? el.locale : null), document_type: (el.document_type ? el.document_type : null) })
          );
        } else if (fileRequired && !hasErrors) {
          this.displayErrorDialog({ message: component.$t('general.validator.file-required') }, component);
          hasErrors = true;
        }
      });
    }
    if (hasErrors) {
      return null;
    }
    return reqData;
  }

  displayErrorDialog (response, component, fieldOverwrite = {}) {
    const message = this.getApiResponseErrorMessage(response, component, fieldOverwrite);

    component.$bvModal.msgBoxOk(message, {
      title: [component.$t('general.error')],
      noFade: true,
      okTitle: component.$t('general.ok')
    });
  }

  displaySuccessDialog (component, message, title) {
    component.$bvModal.msgBoxOk(component.$t(message), {
      title: [component.$t(title)],
      noFade: false,
      okTitle: component.$t('general.ok')
    });
  }

  simulateUser (el, component) {
    const self = this;
    this.request('user/loginas/' + el.api_id, this.REQUEST_GET, {}, function (response) {
      if (response.error) {
        self.displayErrorDialog(response, component);
      } else {
        self.session.set('originalAccessToken', self.session.get('accessToken'));
        self.session.set('accessToken', response.data.token);
        self.session.set('uuid', response.data.user.api_id);
        self.session.set('user', response.data.user.name);
        self.session.set('email', response.data.user.email);
        self.session.set('locale', response.data.user.defaultLang);
        self.session.set('permissions', response.data.user.permissions);
        self.session.set('client_permissions', response.data.user.client_permissions);
        self.session.set('roles', response.data.user.roles.map(a => a.name));
        self.session.set('isSimUser', true);
        component.$root.$i18n.locale = response.data.user.defaultLang;
        self.store.dispatch('loadConfig');
        self.store.dispatch('sessionUpdated');
        self.router.push('/home');
      }
    });
  }
}

export default new ApiRequest()
